export default __webpack_public_path__ + "static/media/HelveticaNeueLight.bbeeb822.woff";